<script lang="ts">
export default {
  name: 'C4FilterTooltip'
};
</script>
<script setup lang="ts">
import type { PropType } from 'vue';

defineProps({
  values: { type: Array as PropType<string[]>, required: true },
  title: { type: String, required: true }
});
</script>

<template>
  <div class="rounded-lg text-white">
    <div class="flex flex-col gap-1">
      <div class="text-sm font-bold">{{ title }}</div>
      <ul class="text-sm pr-3 max-h-32 custom-vertical-scrollbar overflow-y-auto">
        <li v-for="(value, index) in values" :key="index">
          {{ value }}
        </li>
      </ul>
    </div>
  </div>
</template>
